export const environment = {
  production: false,
  apiUrl: "https://api.ews.katdev.com/api/v1",
  // apiUrl: "http://127.0.0.1:3000/api/v1",
  appName: "EWS - Super Admin",
  version: "1.0.0",
  logLevel: "debug",
  /** Inactivity duration before the session warning appears (ms). */
  sessionInactivityMs: 5 * 60 * 1000,
  /** Countdown after the warning appears before automatic logout (ms). */
  sessionWarningResponseMs: 60 * 1000,
  /** Minimum interval between cross-tab activity writes to localStorage (ms). */
  sessionActivityThrottleMs: 2000,
};
